import {Component, Host, h, State, Prop, Event, EventEmitter} from '@stencil/core';
import moment from "moment";
import {Moment} from "moment/moment";
import {NestDatePickerChangeView, NestDatePickerDay} from "../nest-date-picker.interfaces";
import {NestDatePickerHeader} from "../components/nest-date-picker-header";

@Component({
  tag: 'nest-date-picker-month',
  styleUrl: '../nest-date-picker.scss',
  shadow: true,
})
export class NestDatePickerMonthView {
  perLine = 3;
  currentDate: Moment = moment();

  @State() rows = [];
  @State() headerLabel: string;
  @State() headerDisabled = {};

  @Prop({mutable: true}) activeDate: Moment;
  @Prop({mutable: true}) selectedDate: Moment;
  @Prop() minDate: Moment;
  @Prop() maxDate: Moment;

  @Event() changeView: EventEmitter<NestDatePickerChangeView>;

  private generateView(): void {
    const selectedYear: number = (this.activeDate || this.selectedDate).year();
    const months = moment.monthsShort()

    this.headerDisabled = {
      prev: this.minDate && selectedYear <= this.minDate.year(),
      next: this.maxDate && selectedYear >= this.maxDate.year()
    }

    let month = moment([selectedYear]);

    this.rows = [];
    months.forEach((_, i) => {
      let index = Math.floor(i / this.perLine);
      if (!this.rows[index]) this.rows[index] = [];

      this.rows[index].push({
        id: month.month(),
        label: month.format("MMMM"),
        value: `${month.format("MM")}-${month.year()}`,
        year: month.year(),
        month: month.month(),
        current: month.isSame(this.currentDate, "month"),
        selected: month.isSame(this.selectedDate, 'month'),
        disabled: this.minDate && month.isBefore(this.minDate, "month")
          || this.maxDate && month.isAfter(this.maxDate, "month")
      });
      month.add(1, 'months');
    });

    this.headerLabel = String(selectedYear);
  }

  private choose(month: NestDatePickerDay): void {
    if (month.disabled) return;

    this.activeDate = moment([month.year, month.month]);
    this.changeView.emit({view: 'day', answer: this.activeDate});
  }

  private next(): void {
    this.activeDate.add(1, 'year');
    this.generateView()
  }

  private prev(): void {
    this.activeDate.subtract(1, 'year')
    this.generateView()
  }

  /* Lifecycles methods */
  componentWillLoad() {
    this.generateView()
  }

  render() {
    return (
      <Host>
        <NestDatePickerHeader
          actions={[{ label: this.headerLabel, handler: () => this.changeView.emit({view: 'year'}) }]}
          nextHandler={this.next.bind(this)}
          prevHandler={this.prev.bind(this)}
          disabled={this.headerDisabled}
        />

        {this.rows.map(row => (
          <div class='flex flex-wrap mb-1'>
            {row.map((item) => (
              <button
                onClick={() => this.choose(item)}
                disabled={item.disabled}
                type="button"
                class={{
                  'nest-date-picker-item__button': true,
                  'bg-gray-100': !item.selected && item.current,
                  'bg-blue-600 text-white': item.selected,
                  'disabled:text-gray-300 disabled:cursor-default': item.disabled,
                }}>
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </Host>
    )
  }
}
